/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONVENIOS_URL}${process.env.VUE_APP_API_PATH}/convenios/relatorios`

export default {
    emitirRelatorio(relatorio, filtros) {
        let filtrosString = '?'

        if (filtros.convenio) {
            filtrosString = `${filtrosString}convenio=${filtros.convenio.replace(
                '/',
                '-'
            )}&`
        }

        if (filtros.dataInicio) {
            filtrosString = `${filtrosString}dataInicio=${filtros.dataInicio}&`
        }

        if (filtros.dataFim) {
            filtrosString = `${filtrosString}dataFim=${filtros.dataFim}&`
        }

        if (filtros.dataCompetencia) {
            filtrosString = `${filtrosString}dataCompetencia=${filtros.dataCompetencia}&`
        }

        if (filtros.apenasAtivos) {
            filtrosString = `${filtrosString}apenasAtivos=${filtros.apenasAtivos}&`
        }

        if (filtros.pdf) {
            filtrosString = `${filtrosString}pdf=${filtros.pdf}&`
        }

        if (filtros.excel) {
            filtrosString = `${filtrosString}excel=${filtros.excel}&`
        }

        return axiosJwt
            .get(`${api}/${relatorio}${filtrosString}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    EmitirRelatorioTimeLine(relatorio, idConvenio) {

        return axiosJwt.get(`${api}/${relatorio}?idConvenio=${idConvenio}`, { responseType: 'blob' })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return errorHandler(error);
            });
    },
}
